'use strict';

angular.module('admin.article-page', [
    'ng-komondor-resource-view',
])

.factory('saveAsTemplate', function ($http, $state, notify)
{
    return {
        name: 'save-as-template',
        buttonClass: 'btn btn-default',
        template: '<i class="glyphicon glyphicon-duplicate"></i>Save As Template',
        act: function (models)
        {
            notify.confirm('Are you sure ?').result.then(function ()
            {
                return $http.post('/api/templates/createFromPage', {
                    'id' :  models[0].id,
                }).then(function ()
                {
                    notify.alert("Template successfully created!");
                });
            }).catch(function () {
                notify.alert("Template was not created!");
            });
        },
        show: function (models)
        {
            return models.length === 1;
        }
    };
})

.config(function (resourceStateProvider)
{
    resourceStateProvider
    .state('admin.article-pages', {
        url: 'articlePages/{articleId:[0-9\w-]+}',
        model: 'ArticlePage',
        viewOptions: 'articlePageViewOptions',
        title: 'Article Pages',
        modelNameField: 'title',
        edit: {
            templateUrl: 'admin/article-page/articlePage.edit.html',
            controller: 'EditCtrl',
            defaults: {
                display_order: 1,
            }
        },
        root: {
            resolve: {
                viewOptions: [
                    'articlePageViewOptions',
                    '$stateParams',
                    'stateOptions',
                    'Category',
                    'Programme',
                    'Article',
                    '$state',
                    function (viewOptions, $stateParams, stateOptions, Category, Programme, Article, $state)
                    {
                        return Article.find($stateParams.articleId).then(function (article)
                        {
                            return Category.find(article.category_id).then(function (category)
                            {
                                return Programme.find(category.programme_id).then(function (programme)
                                {
                                    if (article) {

                                        var breadcrumb = [];

                                        breadcrumb.push({
                                            name: 'Programmes',
                                            go: function ()
                                            {
                                                $state.go('admin.programmes');
                                            }
                                        });

                                        breadcrumb.push({
                                            name: programme.title,
                                            go: function ()
                                            {
                                                $state.go('admin.categories', {'programmeId' : programme.id});
                                            }
                                        });

                                        breadcrumb.push({
                                            name: category.title,
                                            go: function ()
                                            {
                                                $state.go('admin.articles', {'categoryId' : category.id});
                                            }
                                        });

                                        breadcrumb.push({
                                            name: article.title
                                        });

                                        stateOptions.customBreadcrumb = breadcrumb;

                                        stateOptions.edit.defaults.article_id = article.id;
                                        viewOptions.queryDefaults.where.article_id = article.id;
                                    }

                                    return viewOptions;
                                });
                            });
                        });
                    }
                ]
            }
        }
    });
})

.factory('articlePageViewOptions', function (
    extendDeep,
    resourceViewOptions,
    listNameTemplate,
    saveAsTemplate,
    listView
) {
    var options = extendDeep(angular.copy(resourceViewOptions), {
        with: [
            'article',
            'article.category',
            'article.category.programme',
        ],
        queryDefaults: {
            sort: [
                ['article_id', 'ASC'],
                ['display_order', 'ASC']
            ],
        },
        list: {
            columns: [
                {
                    label: 'Page',
                    name: 'display_order',
                    sortable: true,
                },
                {
                    label: 'Title',
                    name: 'title',
                   // template: listNameTemplate('title'),
                    sortable: true,
                },
                {
                    label: 'Edit',
                    template: '<a ' +
                    'target="__blank"' +
                    'ui-sref="programme.category.article.page({programmeSlug: model.article.category.programme.slug, categorySlug: model.article.category.slug, articleSlug: model.article.slug, pageNum: model.display_order})">' +
                    'Editor' +
                    '</a>',
                    sortable: false,
                },
                {
                    label: 'Last modified',
                    name: 'updated_at',
                    template: '<span class="no-wrap">{{ model.updated_at | date }}</span>',
                    sortable: true,
                },
            ],
        },
        views: [listView],
        sorts: [
            {
                label: 'Display Order',
                sort: 'display_order asc'
            }
        ]
    });

    options.actions.push(saveAsTemplate);

    return options;
});
